import React, { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import api, { setToken } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ChangePassword({ forced }) {
  const { logout, setMustChange } = useAuth();
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: np });
      toast.success("Password changed. Please sign in again.");
      setToken(null);
      setMustChange(false);
      await logout();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not change password");
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 bg-white p-8 rounded-xl border" data-testid="change-password-form">
        <h2 className="text-2xl font-bold text-slate-900">{forced ? "Set your password" : "Change password"}</h2>
        {forced && <p className="text-sm text-slate-500">For security, please set a new password before continuing.</p>}
        <div>
          <Label>Current password</Label>
          <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required />
        </div>
        <div>
          <Label>New password</Label>
          <Input type="password" value={np} onChange={(e) => setNp(e.target.value)} required minLength={6} />
        </div>
        <Button type="submit" className="w-full" data-testid="change-password-submit">Update password</Button>
      </form>
    </div>
  );
}
